/**
 * Byte-size rendering. Every file size shown in the application goes through here.
 *
 * Whole units below a megabyte and one decimal above: a size in a list is read at a glance
 * to answer "roughly how big", never to audit an exact byte count. The exact figure stays
 * available on the record itself.
 */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }

  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} KB`;
  }

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
